const routes = {
  LANDING: `/`,
  LOGIN: `/login`,
  LOGOUT: `/logout`,
  REGISTRATION: `/registration`,
  TICKETS: `/tickets`,
  SEATS: `/seats`,
  ADMIN: `/admin`,
  JOIN: `/join`,
} as const;

export default routes;
